import React, { useEffect, useRef, useState, useLayoutEffect } from "react";

import ReactDOM from "react-dom";
import { KTSVG } from "../../_metronic/helpers";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { DateRangePicker } from "rsuite";
// import "rsuite/dist/rsuite.min.css";
import moment from "moment";
import { ShowToast } from "../../common/Toastr";
import { getValueFromResource, normalizeDateFormat } from "../../common/timeLiveFunction";
import { updateYearFilter } from "./dashboardSlice"; 
import { t } from "i18next";


interface WidgetFilterPopoverProps {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    onCancel?: () => void;
    onApply?: (filters: Record<string, any>) => void;
    savedFilters?: Record<string, any> | null;
    expectedWidgetId?: number;
}

const WidgetFilterPopover: React.FC<WidgetFilterPopoverProps> = ({ anchorEl, onClose, onCancel,onApply, savedFilters, expectedWidgetId }) => {
    const popoverRef = useRef<HTMLDivElement>(null);
    const arrowRef = useRef<HTMLDivElement>(null);
    const { filterData, isFilterLoading, loadedFilterWidgetId} = useAppSelector((state) => state.dashboard);
    const { maxMenuHeight, CurrentCultureDateFormat } = useAppSelector((state) => state.globalState);
    const [isPositioned, setIsPositioned] = useState(false);
     const dispatch = useAppDispatch();
    const [pos, setPos] = useState<{
        top: number;
        left: number;
        arrowLeft: number;
        placement: "top" | "bottom";
    }>({ top: 0, left: 0, arrowLeft: 0, placement: "bottom" });
    const [filters, setFilters] = useState<Record<string, any>>({});
    const defaultFiltersRef = useRef<Record<string, any>>({});
    const isReady = !isFilterLoading && loadedFilterWidgetId === expectedWidgetId;
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');



    useEffect(() => {
        if (!filterData) return;

        if (savedFilters && Object.keys(savedFilters).length > 0) {
            const restoredFilters: Record<string, any> = {};

            filterData.forEach((item: any) => {
                const savedVal = savedFilters[item.FilterField];
                if (savedVal === undefined) return;

                if (item.FilterType === "DateRange" && savedVal?.startDate) {
                    restoredFilters[item.FilterField] = [
                        new Date(savedVal.startDate),
                        new Date(savedVal.endDate)
                    ];
                } else if (item.FilterType === "Dropdown") {
                    if (Array.isArray(savedVal)) {
                        const matched = item.Options?.filter((opt: any) =>
                            savedVal.includes(opt.value)
                        );
                        restoredFilters[item.FilterField] = item?.isMulti
                            ? matched
                            : matched?.[0] || null;
                    }
                } else if (item.FilterType === "CheckBox") {
                    restoredFilters[item.FilterField] = savedVal;
                }
            });

            setFilters(restoredFilters);
            defaultFiltersRef.current = restoredFilters;
            return;
        }
        const today = new Date();
        const defaultFilters: Record<string, any> = {};
        filterData.forEach((item: any) => {
            if (item.FilterType === "DateRange") {
                defaultFilters[item.FilterField] = [today, today];
            }
            // if (item.FilterType === "Dropdown" && item.Options?.length) {
            //     const first = item.Options.find((x: any) => x.value === 0) || item.Options[0];
            //     defaultFilters[item.FilterField] = item?.isMulti ? [first] : first;
            // }
            if (item.FilterType === "Dropdown" && item.Options?.length) {
                let selectedOption = null;
                if ((expectedWidgetId === 5 || expectedWidgetId === 6) && item.FilterField === "AccountEmployeeId" && AccountEmployeeId) {
                    selectedOption = item.Options.find(
                        (opt: any) => String(opt.value) === String(AccountEmployeeId)
                    );
                }

                if (!selectedOption) {
                    selectedOption = item.Options.find((x: any) => x.value === 0) || item.Options[0];
                }

                defaultFilters[item.FilterField] = item?.isMulti ? selectedOption ? [selectedOption] : [] : selectedOption;
            }
            if (item.FilterType === "CheckBox") {
                defaultFilters[item.FilterField] = false;
            }
        });
        setFilters(defaultFilters);
        defaultFiltersRef.current = defaultFilters;

    }, [filterData, savedFilters]);

    useLayoutEffect(() => {
        if (!anchorEl || !popoverRef.current) return;

        const calculatePosition = () => {
            if (!popoverRef.current) return;

            const popW = popoverRef.current.offsetWidth;
            const popH = popoverRef.current.offsetHeight;

            if (!popW || !popH) return;

            const anchor = anchorEl.getBoundingClientRect();
            const scrollY = window.scrollY;
            const scrollX = window.scrollX;
            const viewportMid = window.innerWidth / 2;
            const anchorMid = anchor.left + anchor.width / 2;
            const minLeft = 8;
            const maxLeft = window.innerWidth - popW - 8;

            let left: number;
            if (anchorMid < viewportMid) {
                left = anchor.left + scrollX;
            } else {
                left = anchor.right + scrollX - popW;
            }
            left = Math.max(minLeft, Math.min(left, maxLeft));

            const spaceBelow = window.innerHeight - anchor.bottom;
            const spaceAbove = anchor.top;
            let top: number;
            let placement: "top" | "bottom";

            if (spaceBelow < popH + 16 && spaceAbove > spaceBelow) {
                top = anchor.top + scrollY - popH - 8;
                placement = "top";
            } else {
                top = anchor.bottom + scrollY + 8;
                placement = "bottom";
            }

            const arrowLeft = anchorMid + scrollX - left;
            setPos({ top, left, arrowLeft, placement });
            setIsPositioned(true);
        };

        const observer = new ResizeObserver(() => {
            calculatePosition();
        });
        observer.observe(popoverRef.current);
        calculatePosition();

        return () => observer.disconnect();
    }, [anchorEl, isReady]);

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            if (target.closest(".rs-picker-daterange-menu")) {
                return;
            }
            if (
                popoverRef.current &&
                !popoverRef.current.contains(e.target as Node) &&
                anchorEl &&
                !anchorEl.contains(e.target as Node)
            ) {
                onClose();
            }
        };
        const timer = setTimeout(() => {
            document.addEventListener("mousedown", handler);
        }, 0);

        return () => {
            clearTimeout(timer);
            document.removeEventListener("mousedown", handler);
        };
    }, [onClose, anchorEl]);

    const resetFilters = () => {
        if (!filterData) return;
        const today = new Date();
        const defaultFilters: Record<string, any> = {};
        filterData.forEach((item: any) => {
            if (item.FilterType === "DateRange") {
                defaultFilters[item.FilterField] = [today, today];
            }
            if (item.FilterType === "Dropdown" && item.Options?.length) {
                const first = item.Options.find((x: any) => x.value === 0) || item.Options[0];
                defaultFilters[item.FilterField] = item?.isMulti ? [first] : first;
            }
            if (item.FilterType === "CheckBox") {
                defaultFilters[item.FilterField] = false;
            }
        });
        setFilters(defaultFilters);
    };

    const handleApply = () => {
        const isSame = JSON.stringify(filters) === JSON.stringify(defaultFiltersRef.current);
        if (isSame) {
            onClose();
            return;
        }
        const payload: Record<string, any> = {};
        const checkboxItems = (filterData ?? []).filter(
            (item: any) => item.FilterType === "CheckBox"
        );
        const hasCheckbox = checkboxItems.length > 0;
        const anyCheckboxTrue = checkboxItems.some(
            (item: any) => filters[item.FilterField] === true
        );
        const allowDateRange = !hasCheckbox || anyCheckboxTrue;

        Object.entries(filters).forEach(([field, value]: any) => {
            const isDateRangeField = (filterData ?? []).find(
                (item: any) => item.FilterField === field && item.FilterType === "DateRange"
            );
            if (isDateRangeField && !allowDateRange) {
                return;
            }

            if (Array.isArray(value) && value[0]?.value !== undefined) {
                payload[field] = value.map((v: any) => v.value);
            } else if (value && value.value !== undefined) {
                payload[field] = [value.value];
            } else if (Array.isArray(value) && value.length === 2) {
                payload[field] = {
                    startDate: moment(value[0]).format("YYYY-MM-DD"),
                    endDate: moment(value[1]).format("YYYY-MM-DD"),
                };
            } else if (typeof value === "boolean") {
                payload[field] = value;
            }
        });

        onApply?.(payload);
        resetFilters();
        onClose();
    };

    const isBeyondThreeMonths = (start: Date, end: Date) => {
        const startYear = start.getFullYear();
        const startMonth = start.getMonth();
        const endYear = end.getFullYear();
        const endMonth = end.getMonth();
        const monthDiff = (endYear - startYear) * 12 + (endMonth - startMonth);
        return monthDiff > 2;
    };

    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
            .rs-picker-daterange-menu {
                z-index: 9999 !important;
            }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const dropdownItems = (filterData ?? []).filter((item: any) => item.FilterType === "Dropdown");
    const otherItems = (filterData ?? []).filter((item: any) => item.FilterType !== "Dropdown");

    const isSingleDropdown = dropdownItems.length === 1;
    const hasCheckbox = otherItems.some((item: any) => item.FilterType === "CheckBox");

    const getDropdownColClass = () => {
        const count = dropdownItems.length;
        if (count === 1) return "col-12";
        if (count === 2) return "col-6";
        return "col-4";
    };

    const getPopoverWidth = () => {
        if (!isReady) return 400;
        const count = dropdownItems.length;
        if (count === 1) return 400;
        if (count === 2) return 520;
        return 700;
    };

    const dropDownSelectionStyles = {
        menuPortal: (base: any) => ({
            ...base,
            zIndex: 9999,
        }),
        menu: (base: any) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    const popover = (
        <div
            ref={popoverRef}
            className="popover bs-popover-bottom show shadow"
            style={{
                position: "absolute",
                top: pos.top - 10,
                left: pos.left - 2,
                width: getPopoverWidth(),
                maxWidth: "calc(100vw - 16px)",
                zIndex: 1060,
                visibility: isPositioned ? "visible" : "hidden",
                border: "1px solid #e0e0e0",
                borderRadius: '12px'
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <div
                ref={arrowRef}
                className="popover-arrow"
                style={{ left: pos.arrowLeft, transform: "none" }}
            />

            <div className="popover-header d-flex justify-content-between align-items-center py-2 px-3">
                <span className="fw-semibold fs-7 text-dark">{getValueFromResource("Card Filters", dispatch, t)}</span>
                <div
                    className="btn btn-icon btn-active-secondary"
                    onClick={onClose}
                    style={{ width: "24px", height: "24px", padding: "4px" }}
                >
                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon" />
                </div>
            </div>

            <div className="popover-body px-2 pt-2 pb-1">
                {!isReady ? (
                    <div className="popover-body px-2 pt-2 pb-1">
                        <div className="d-flex justify-content-center align-items-center py-4">
                            <span className="spinner-border spinner-border-sm me-2" />
                            <span style={{ fontSize: 13, color: "#6B7280" }}>Loading filters...</span>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="row g-2 mb-3">
                            {dropdownItems.map((item: any) => (
                                <div className={getDropdownColClass()} key={item.FilterSourceId}>
                                    <label className="form-label fs-7 fw-normal mb-2">
                                        {/* {item.Caption} */}
                                        {getValueFromResource(`${item.Caption}`, dispatch, t)}
                                    </label>
                                    <Select
                                        isMulti={item?.isMulti}
                                        placeholder={item.FilterField || "Select..."}
                                        value={filters[item.FilterField] || []}
                                        // options={item.Options}
                                        options={ (expectedWidgetId === 5 || expectedWidgetId === 6) ? item.Options?.filter((opt: any) => opt.value !== 0) : item.Options}
                                        styles={dropDownSelectionStyles}
                                        menuPortalTarget={document.body}
                                        maxMenuHeight={maxMenuHeight}
                                        menuPlacement="auto"
                                        onChange={(val: any) =>
                                            setFilters((prev) => ({
                                                ...prev,
                                                [item.FilterField]: val,
                                            }))
                                        }
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="row g-2 align-items-end mb-3">
                            {otherItems.filter((item: any) => item.FilterType === "CheckBox").map((item: any) => (
                                <div
                                    // className="col-6 d-flex flex-column"
                                    className={isSingleDropdown && hasCheckbox ? "col-4 d-flex flex-column" : "col-6 d-flex flex-column"}
                                    key={item.FilterSourceId}
                                >
                                    <label className="form-label fs-7 fw-normal mb-2">
                                        {/* {item.Caption} */}
                                        {getValueFromResource(`${item.Caption}`, dispatch, t)}
                                    </label>
                                    <div
                                        className="form-check form-switch ms-2"
                                        style={{ height: "38px", display: "flex", alignItems: "center", marginBottom: 0 }}
                                    >
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id={item.FilterField}
                                            checked={filters[item.FilterField] || false}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    [item.FilterField]: e.target.checked,
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}

                            {otherItems.filter((item: any) => item.FilterType === "DateRange").map((item: any) => (
                                <div
                                    // className="col-6"
                                    className={isSingleDropdown ? hasCheckbox ? "col-8" : "col-12" : "col-6"}
                                    key={item.FilterSourceId}
                                >
                                    <label className="form-label fs-7 fw-normal mb-2">
                                        {/* --- Yahan Condition Lagi Hai --- */}
                                        {  expectedWidgetId === 14 ? "Timesheet Date Range" :
                                            expectedWidgetId === 15 ? "Expense Date Range" :
                                                expectedWidgetId === 16 ? "Time Off Date Range" :
                                                    getValueFromResource(`${item.Caption}`, dispatch, t)
                                        }
                                        {/* --------------------------------- */}

                                        <span style={{ fontSize: 11, fontStyle: "italic", opacity: 0.8, marginLeft: "4px" }}>
                                            (Max. 3 months)
                                        </span>
                                    </label>
                                    {/* <label className="form-label fs-7 fw-normal mb-2">
                                        {getValueFromResource(`${item.Caption}`, dispatch, t)} <span style={{ fontSize: 11, fontStyle: "italic", opacity: 0.8, marginLeft: "4px" }}>(Max. 3 months)</span>
                                    </label> */}
                                    <DateRangePicker
                                        value={filters[item.FilterField] || [new Date(), new Date()]}
                                        disabled={
                                            hasCheckbox &&
                                            !otherItems
                                                .filter((x: any) => x.FilterType === "CheckBox")
                                                .some((x: any) => filters[x.FilterField] === true)
                                        }
                                        onChange={(val: any) => {
                                            if (!val || val.length !== 2) return;
                                            const [start, end] = val;
                                            if (isBeyondThreeMonths(start, end)) {
                                                ShowToast("Error", "You cannot select date range more than 3 months", "error", "toast-top-right");
                                                return;
                                            }
                                            setFilters((prev) => ({
                                                ...prev,
                                                [item.FilterField]: val,
                                            }));
                                        }}
                                        cleanable={false}
                                        character=" - "
                                        format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                                        // placement="bottom"
                                        container={() => document.body}
                                        placement="auto"
                                        preventOverflow={true}
                                    />
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>

            <div className="d-flex align-items-center justify-content-end border-top px-3 py-2">
                <div className="d-flex gap-2">
                    <button className="btn btn-light btn-sm fs-7" onClick={() => onCancel ? onCancel() : onClose()}>
                         {getValueFromResource("Reset Filter", dispatch, t)}
                    </button>
                    <button className="btn btn-primary btn-sm fs-7" onClick={handleApply}>
                        {getValueFromResource("Apply", dispatch, t)}
                    </button>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(popover, document.body);
};

export default WidgetFilterPopover;